<template>
  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="12.5" y="12.5" width="75" height="75" rx="12.5" stroke="#313743" stroke-width="2"/>
  </svg>
</template>

<script>

</script>

<style scoped lang="scss">

</style>
